import { useCallback } from 'react'

export default function WorkbenchPage() {
  const openWorkbench = useCallback(() => {
    window.open('https://api.boxiaotu.cn/video-workbench/', '_blank')
  }, [])

  return (
    <div style={{ padding: 60, textAlign: 'center', background: '#fff', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ fontSize: 64, marginBottom: 24 }}>🎬</div>
      <h2 style={{ marginBottom: 16, color: '#333' }}>博小兔视频工作台</h2>
      <p style={{ color: '#666', marginBottom: 8, fontSize: 15 }}>
        视频工作台将在新标签页打开
      </p>
      <p style={{ color: '#999', marginBottom: 32, fontSize: 13 }}>
        编辑视频、AI解说配音、营销视频生成等功能
      </p>
      <button
        onClick={openWorkbench}
        style={{
          padding: '14px 48px',
          background: 'linear-gradient(135deg, #722ed1, #1890ff)',
          color: '#fff',
          border: 'none',
          borderRadius: 12,
          cursor: 'pointer',
          fontSize: 18,
          fontWeight: 'bold',
          boxShadow: '0 4px 14px rgba(114,46,209,0.3)',
        }}
      >
        🚀 打开视频工作台
      </button>
      <p style={{ color: '#bbb', marginTop: 24, fontSize: 12 }}>
        如果点击无效，请在浏览器设置中允许弹窗
      </p>
    </div>
  )
}
